export default "__VITE_ASSET__B_0KemwW__"